import api from "./api.ts";

export async function createPaymentIntent(email: string, country: string) {
  return api.post("/payments/create-payment-intent", { email, country });
}

export async function confirmPayment(email: string, paymentIntentId: string) {
  return api.post("/payments/confirm", { email, payment_intent_id: paymentIntentId });
}
